var clog = console.log.bind(console, 'DEBUG:');

jQuery(document).ready(function ($) {
	
	// add fancybox to all galleries that have their images linked
	$(".gallery-icon a").fancybox();
	
	/** make the main homepage banner fill the available height of the device **/
	
	
	$(window).load(function () {
		console.log($(window).height(), $('.headerMain').outerHeight());
		$('.slideshow.fullscreen:first-of-type').height($(window).height() - $('.headerMain').height());
	});
	
	
	/**
	 * Make unlimited number of child dropdowns
	 */
	$('.header-navigation.navbar a.dropdown-toggle').on('click', function (e) {
		var $el = $(this);
		var $parent = $(this).offsetParent('.dropdown-menu');
		$(this).parent('li').toggleClass('open');
		
		clog($parent);
		
		if (!$parent.parent().hasClass('nav')) {
			$el.next().css({'top': $el[0].offsetTop, 'left': $parent.outerWidth() - 4});
		}
		
		$('.nav li.open').not($(this).parents('li')).removeClass('open');
		
		return false;
	});
	
	$('.mh-item').matchHeight();
	
	$('.navMain__list').dropit();
	
	
	/***
	 * MOBILE MENU STUFF
	 */
	var $mobileMenuItems = $('#menu-mobile .sub-menu');
	$mobileMenuItems.each(function () {
		$(this).prepend('<li class="mobile-menu-back"><a href="javascript:void(0);">Back</a></li>');
	});
	
	$('body').on('click', '.mobile-menu-back', function (e) {
		e.stopPropagation();
		$(this).closest('.w-open').removeClass('w-open');
	});
	
	$('#menu-mobile li:not(.menu-item-has-children, .mobile-menu-back) a').click(function (e) {
		e.stopPropagation();
	});
	
	
	$('body').on('click', '#menu-mobile li.menu-item-has-children', function (e) {
		
		e.stopPropagation();
		
		var $this = $(this);
		var openClass = 'w-open';
		
		if ($this.hasClass('menu-item-has-children')) {
			e.preventDefault();
		}
		
		if (!$this.hasClass(openClass)) {
			$this.addClass(openClass);
		}
	});
	
	/**
	 * END MOBILE MENU STUFF
	 */
	
	
	$('body').on('click', '.js-nav-trigger', function (e) {
		e.preventDefault();
		$('body').addClass('nav-is-open');
		$('.headerMain-nav').slideToggle();
	});
	
	
});
